module.exports = __webpack_public_path__ + "static/img/compass.c5f2e0a4.svg";